import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import { DATE_FORMATS } from "../../constants";
import Dropdown from "../dropdown";
import { RillContext, useRillContext } from "../../rill/RillReact/share/base";

const { DATE_DAY_FORMAT, DATE_PICKER_FORMAT_FULL_MONTH } = DATE_FORMATS;

const CalendarShiftWorkout = (props) => {
  const { t } = useTranslation("coaching-portal");
  const {
    locals: { query },
  } = useRillContext();
  const [weeks, setWeeks] = useState(1);

  const actualDate = moment
    .utc(query.day, DATE_DAY_FORMAT)
    .format(DATE_PICKER_FORMAT_FULL_MONTH);
  const nextDate = moment
    .utc(query.day, DATE_DAY_FORMAT)
    .add("weeks", weeks)
    .format(DATE_PICKER_FORMAT_FULL_MONTH);

  return (
    <form
      action={`/actions/exercise/shift-day?proxyAthlete=${query.athlete}`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="weeks" value={weeks} />
      <input type="hidden" name="from" value={query.day} />

      <Modal
        className="Shift-Workout export-workout"
        title={t("calendarShiftWorkout.title")}
        toClear={["day"]}
      >
        <div className="body">
          <p className="p2">
            {t("calendarShiftWorkout.howManyWeeks")}{" "}
            <span className="font-bold text-(--text-primary)">
              {actualDate}
            </span>
          </p>

          <label className="mt-8">{t("calendarShiftWorkout.weeks")}</label>
          <Dropdown
            options={[1, 2, 3, 4, 5, 6, 7, 8].map((week) => ({
              text: week,
              value: week,
            }))}
            summaryText={weeks}
            onSelectFn={(newVal) => setWeeks(newVal)}
          />
          {/* <select onChange={(evt) => setWeeks(evt.target.value)}>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((week, idx) => (
              <option key={idx}>{week}</option>
            ))}
          </select> */}

          <div className="flex items-center justify-between mt-5">
            <p className="p2">{t("calendarShiftWorkout.programResumeOn")}</p>
            <p className="clipped font-bold">{nextDate}</p>
          </div>
        </div>

        <footer>
          <a
            role="button"
            data-button-type="text-white"
            data-action="cancel"
            href="/actions/refresh?modal[type]=&day="
          >
            {t("common:cancel")}
          </a>
          <button role="button" data-button-type="primary" type="submit">
            {t("calendarShiftWorkout.shift")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default CalendarShiftWorkout;
